import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function FreeScanBanner() {
  const [domain, setDomain] = useState("");
  const navigate = useNavigate();

  function handleSubmit(e) {
    e.preventDefault();
    const params = domain.trim() ? `?domain=${encodeURIComponent(domain.trim())}` : "";
    navigate(`/free-scan${params}`);
  }

  return (
    <section className="w-full px-gutter max-w-container-max mx-auto mb-section-gap">
      <div className="bg-surface-card-light dark:bg-surface-card-dark backdrop-blur-lg border border-glass rounded-xl p-card-padding flex flex-col md:flex-row items-center justify-between gap-8 shadow-sm">
        <div className="flex-1">
          <span className="font-eyebrow text-eyebrow text-severity-warning uppercase tracking-widest mb-2 block">
            Limited-Time Offer
          </span>
          <h2 className="font-headline-card text-headline-card text-on-surface dark:text-surface-bright mb-2">
            Get a Free Leak &amp; Exposure Report for Your Domain
          </h2>
          <p className="font-body-md text-body-md text-on-surface-variant dark:text-surface-variant text-sm">
            We'll scan stealer malware logs for corporate credential exposure tied to your
            company, then send a detailed report to your official inbox.
          </p>
        </div>
        <form
          onSubmit={handleSubmit}
          className="flex-shrink-0 w-full md:w-auto flex flex-col sm:flex-row gap-3"
        >
          <input
            className="bg-surface-container-lowest dark:bg-white/5 border border-glass rounded-DEFAULT px-4 py-3 font-body-md text-body-md text-on-surface dark:text-surface-bright focus:outline-none focus:border-primary-container w-full sm:w-64"
            placeholder="Enter company domain..."
            type="text"
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
          />
          <button
            type="submit"
            className="bg-surface-dark text-surface-bright font-headline-card text-[14px] px-6 py-3 rounded-DEFAULT hover:bg-on-surface transition-colors whitespace-nowrap"
          >
            Request Free Report
          </button>
        </form>
      </div>
    </section>
  );
}
